import { Bookstore, Institution, Professor } from 'src/types/institution';
import { ID } from 'src/types/common';
import { Term } from 'src/types/course';

export enum OrderType {
  New = 'NEW_ORDER',
  ExactRepeat = 'EXACT_REPEAT',
  ReOrder = 'RE_ORDER',
  Copyright = 'COPYRIGHT_ONLY',
}

export enum ProductionType {
  Print = 'PRINT',
  Digital = 'DIGITAL',
  All = 'PRINT_AND_DIGITAL',
}

export enum DigitalPlatform {
  LAD = 'LAD',
  VitalSource = 'VITAL_SOURCE',
  Kortext = 'KORTEXT',
  // Redshelf = 'REDSHELF',
  FullGlass = 'FULL_GLASS',
  Other = 'OTHER',
}

export enum PrintType {
  SingleSided = 'SINGLE_SIDED',
  DoubleSided = 'DOUBLE_SIDED',
  AsIs = 'AS_IS',
}

export enum BindingType {
  Coil = 'COIL',
  Shrinkwrap = 'SHRINKWRAP',
  Tape = 'TAPE',
  Perfect = 'PERFECT_BINDING',
  Other = 'OTHER',
}

export enum ContactType {
  Creator = 'CREATOR',
  Store = 'BOOKSTORE',
  Other = 'OTHER',
}

export enum CoverType {
  Custom = 'CUSTOM_FACULTY_PROVIDED',
  School = 'LAD_DESIGNED_SCHOOL_SPECIFIC',
  Discipline = 'LAD_DESIGNED_DISCIPLINE_SPECIFIC',
  SchoolDiscipline = 'LAD_DESIGNED_SCHOOL_DISCIPLINE_SPECIFIC',
  Standard = 'LAD_DESIGNED_STANDARD',
}

export enum RequestMaterialType {
  FILE = 'FILE',
  MAIL_IN = 'MAIL_IN',
  REQUEST = 'REQUEST',
  NO_MATERIAL = 'NO_MATERIAL',
}

export enum RequestOwnMaterials {
  Own = 'OWN',
  OtherSources = 'OTHER_SOURCES',
  OwnAndOther = 'OWN_AND_OTHER',
}

export enum RequestStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  InProcess = 'IN_PROCESS',
  InProduction = 'IN_PRODUCTION',
  New = 'NEW',
}

export type OrderRequest = {
  addToLadLibrary?: boolean;
  binding?: BindingType;
  bookstore?: Bookstore;
  bookstoreId?: ID;
  class?: string;
  contactEmail: string;
  contactName: string;
  contactPhone: string;
  contactType: ContactType;
  courseName: string;
  courseNumber: string;
  coverPage?: CoverType;
  digitalPlatform?: DigitalPlatform;
  dueDateInBookstore?: string;
  estimatedEnrollment: number;
  estimatedPrice: number | null;
  orderIsbn?: string;
  shipmentProvider?: string;
  shipmentTrackingNumber?: string;
  firstDayOfClass?: string;
  institution: Institution;
  institutionId: number;
  isbn?: string;
  materials: any[];
  orderQty?: number;
  orderType: OrderType;
  otherDigitalPlatform?: string;
  poNumber?: string;
  productionProperties?: string[];
  productionInstructions?: string;
  ownMaterials: RequestOwnMaterials;
  pagination?: boolean;
  printing?: PrintType;
  productionType?: ProductionType;
  professorDeskCopies?: number;
  professors: Professor[];
  requestId: number;
  nextRequest?: OrderRequest;
  royaltiesAmount?: string;
  sku?: string;
  specialInstructions?: string;
  tableOfContents?: boolean;
  term: Term;
  termId: number;
  status: RequestStatus;
  wantsRoyalties?: boolean;
};
